import React from 'react';
import { FISH_IMAGES } from '../../../../core/constants/fishImagesArray';
import { TranslationKeys } from '../../../../enums/translationKeys';

const InfoOddBlock = ({ t }) => {
  return (
    <>
      <div className='fs-help-popup-text'>
        <p className='text-b'>{t(TranslationKeys.GAME_RULES_P9)}</p>
      </div>
      <div className='fs-adds-table-wrapper'>
        <div className='fs-adds-table-wrp'>
          <table className='fs-adds-table'>
            <tbody>
              <tr>
                <td className='fish-col' colSpan='4'>
                  <img src={FISH_IMAGES[21]} alt='' />
                </td>
                <td colSpan='4'>x5</td>
              </tr>
              <tr>
                <td className='fish-col' colSpan='4'>
                  <img src={FISH_IMAGES[20]} alt='' />
                </td>
                <td colSpan='4'>x4.8</td>
              </tr>
              <tr>
                <td className='fish-col' colSpan='4'>
                  <img src={FISH_IMAGES[19]} alt='' />
                </td>
                <td colSpan='4'>x4.4</td>
              </tr>
              <tr>
                <td className='fish-col' colSpan='4'>
                  <img src={FISH_IMAGES[18]} alt='' />
                </td>
                <td colSpan='4'>x4.2</td>
              </tr>
              <tr>
                <td className='fish-col' colSpan='4'>
                  <img src={FISH_IMAGES[17]} alt='' />
                </td>
                <td colSpan='4'>x4</td>
              </tr>
              <tr>
                <td className='fish-col' colSpan='4'>
                  <img src={FISH_IMAGES[16]} alt='' />
                </td>
                <td colSpan='4'>x3.8</td>
              </tr>
              <tr>
                <td className='fish-col' colSpan='4'>
                  <img src={FISH_IMAGES[14]} alt='' />
                </td>
                <td colSpan='4'>x3.4</td>
              </tr>
              <tr>
                <td className='fish-col' colSpan='4'>
                  <img src={FISH_IMAGES[13]} alt='' />
                </td>
                <td colSpan='4'>x3.2</td>
              </tr>
              <tr>
                <td className='fish-col' colSpan='4'>
                  <img src={FISH_IMAGES[12]} alt='' />
                </td>
                <td colSpan='4'>x3</td>
              </tr>
              <tr>
                <td className='fish-col' colSpan='4'>
                  <img src={FISH_IMAGES[11]} alt='' />
                </td>
                <td colSpan='4'>x2.8</td>
              </tr>
              <tr>
                <td className='fish-col' colSpan='4'>
                  <img src={FISH_IMAGES[9]} alt='' />
                </td>
                <td colSpan='4'>x2.4</td>
              </tr>
              <tr>
                <td className='fish-col' colSpan='4'>
                  <img src={FISH_IMAGES[8]} alt='' />
                </td>
                <td colSpan='4'>x2.2</td>
              </tr>
              <tr>
                <td className='fish-col' colSpan='4'>
                  <img src={FISH_IMAGES[7]} alt='' />
                </td>
                <td colSpan='4'>x2</td>
              </tr>
              <tr>
                <td className='fish-col' colSpan='4'>
                  <img src={FISH_IMAGES[6]} alt='' />
                </td>
                <td colSpan='4'>x1.8</td>
              </tr>
              <tr>
                <td className='fish-col' colSpan='4'>
                  <img src={FISH_IMAGES[5]} alt='' />
                </td>
                <td colSpan='4'>x1.6</td>
              </tr>
              <tr>
                <td className='fish-col' colSpan='4'>
                  <img src={FISH_IMAGES[4]} alt='' />
                </td>
                <td colSpan='4'>x1.4</td>
              </tr>
              <tr>
                <td className='fish-col' colSpan='4'>
                  <img src={FISH_IMAGES[3]} alt='' />
                </td>
                <td colSpan='4'>x1.2</td>
              </tr>
              <tr>
                <td className='fish-col' colSpan='4'>
                  <img src={FISH_IMAGES[0]} alt='' />
                </td>
                <td colSpan='4'>x1</td>
              </tr>
              <tr>
                <td className='fish-col' colSpan='4'>
                  <img src={FISH_IMAGES[1]} alt='' />
                </td>
                <td colSpan='4'>x0.5</td>
              </tr>
              <tr>
                <td className='fish-col' colSpan='4'>
                  <img src={FISH_IMAGES[2]} alt='' />
                </td>
                <td colSpan='4'>x0</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </>
  );
};

export default InfoOddBlock;
